import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Pipe({
  name: 'xCurrency',
  pure: false,
})
export class XCurrencyPipe implements PipeTransform, OnDestroy {

  locale;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private translateService: TranslateService
  ) {
    this.locale = this.translateService.currentLang;
    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.locale = value.lang;
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  transform(value: any, currency: string): any {
    return formatCurrency(
      Number(value),
      this.locale,
      getCurrencySymbol(currency, "narrow", this.locale),
      '1.2-2');
  }

}
